import { render } from "./BlocksTableHomepage.vue?vue&type=template&id=0e47dce1"
import script from "./BlocksTableHomepage.vue?vue&type=script&lang=js"
export * from "./BlocksTableHomepage.vue?vue&type=script&lang=js"

import "./BlocksTableHomepage.vue?vue&type=style&index=0&id=0e47dce1&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__